import {
    AvatarChip,
    AvatarGroup,
    Button,
    CellItem,
    CompanyAvatar,
    IconAvatar,
    Menu,
    OverflowingTypography,
    Radio,
    Stack,
    Typography,
    chipClasses,
} from "@biggeo/bg-ui/lab";
import {
    ArrowBackOutline,
    DatalabIcon,
    DatascapeIcon,
    UnfoldMoreOutline,
    datascapeLogoPng,
} from "@biggeo/bg-ui/lab/icons";
import { useState } from "react";

import { AuthenticatedUser, Product } from "@biggeo/bg-server-lib/studio";
import { BigGeoLink } from "../../common/components/BigGeoLink";
import { Icon } from "@mui/material";

export const PortalMenu = ({
    user,
    products,
    swapProductAuth,
    swapProductLoading,
    selectedProduct,
}: {
    readonly user: AuthenticatedUser;
    readonly products: readonly Product[];
    readonly swapProductAuth: (productId: string) => void;
    readonly swapProductLoading?: boolean;
    readonly selectedProduct?: Product;
}) => {
    const [open, setOpen] = useState(false);

    return (
        <Menu
            open={open}
            onOpenChange={(open) => setOpen(open)}
            placement="bottom-start"
            sx={{
                padding: 0,
                maxWidth: 55,
                width: "100%",
                gap: 0,
                scrollbarGutter: "auto",
            }}
            content={
                <>
                    <Typography
                        variant="body3"
                        fontWeight="semibold"
                        textColor="disabled.onContainer"
                        sx={{
                            padding: 2,
                        }}
                    >
                        Switch product portal
                    </Typography>
                    <Stack gap={1} sx={{ padding: 2 }}>
                        {products.map((product) => (
                            <CellItem
                                disabled={swapProductLoading}
                                key={product.id}
                                startNode={
                                    <IconAvatar
                                        size="xxs"
                                        sx={{
                                            border: 1,
                                            borderColor: (theme) =>
                                                theme.palette.background.main,
                                        }}
                                    >
                                        <DatascapeIcon />
                                    </IconAvatar>
                                }
                                endNode={
                                    <Radio
                                        checked={
                                            product.id === selectedProduct?.id
                                        }
                                        as="div"
                                    />
                                }
                                title={product.name}
                                subtitle={
                                    <OverflowingTypography
                                        textColor="disabled.onContainer"
                                        variant={"body4"}
                                    >
                                        {product.description}
                                    </OverflowingTypography>
                                }
                                onClick={() => swapProductAuth(product.id)}
                                sx={{
                                    padding: 2,
                                }}
                            />
                        ))}
                        <BigGeoLink
                            variant="new-tab"
                            href="https://datalab.biggeo.com/"
                            tabIndex={-1}
                        >
                            <CellItem
                                startNode={
                                    <IconAvatar
                                        size="xxs"
                                        sx={{
                                            border: 1,
                                            borderColor: (theme) =>
                                                theme.palette.background.main,
                                        }}
                                    >
                                        <DatalabIcon />
                                    </IconAvatar>
                                }
                                title="DataLab"
                                subtitle="Data Management"
                                slotProps={{
                                    subtitle: {
                                        textColor: "disabled.onContainer",
                                        variant: "body4",
                                    },
                                }}
                                sx={{
                                    padding: 2,
                                }}
                                endNode={<Radio checked={false} as="div" />}
                            />
                        </BigGeoLink>
                    </Stack>
                    {/* <Stack sx={{ padding: 2 }}>
                        <Button
                            variant="outlined"
                            fullWidth
                            startNode={<ArrowBackOutline size="xs" />}
                            density="dense"
                            onClick={() => {}}
                        >
                            Back to Studio
                        </Button>
                    </Stack> */}
                </>
            }
        >
            <AvatarChip
                density="dense"
                variant="outlined"
                focused={open}
                startNode={
                    <AvatarGroup size="xxs">
                        <CompanyAvatar
                            src={user.organization?.img || ""}
                            alt={user.organization?.name}
                        />
                        <IconAvatar
                            sx={{
                                border: 1,
                                borderColor: (theme) =>
                                    theme.palette.background.main,
                            }}
                        >
                            <DatascapeIcon />
                        </IconAvatar>
                    </AvatarGroup>
                }
                endNode={
                    <UnfoldMoreOutline
                        size="sm"
                        sx={{
                            transform: open ? "scale(1.25)" : "none",
                            transition: "transform 0.05s ease-in-out",
                        }}
                    />
                }
                slotProps={{
                    label: {
                        align: "left",
                        sx: {
                            flexGrow: 1,
                        },
                    },
                }}
                sx={{
                    width: "100%",
                    [`&.${chipClasses.outlined}`]: {
                        boxShadow: (theme) =>
                            `inset 0 0 0 1px ${theme.palette.stroke[100]}`,
                    },
                }}
            >
                {selectedProduct?.name || ""}
            </AvatarChip>
        </Menu>
    );
};
